import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Motion";

const OPTIONS = [
  { to: "/contact?type=suppliers", label: "I have inventory to offer", id: "suppliers" },
  { to: "/contact?type=retail-buyers", label: "I buy for off-price retail", id: "buyers" },
  { to: "/contact?type=business-partnerships", label: "I want to discuss a partnership", id: "partners" },
];

export const CtaBand = () => (
  <section className="container-x section" data-testid="cta-section">
    <div className="grid gap-12 lg:gap-16 lg:grid-cols-12 lg:items-end">
      <Reveal className="lg:col-span-5">
        <p className="eyebrow mb-6 text-[var(--ink-soft)]">Start a conversation</p>
        <h2 className="font-serif-display text-[2rem] sm:text-4xl lg:text-[2.75rem] leading-[1.1] max-w-[18ch]">
          Have merchandise to move, or an assortment to fill?
        </h2>
      </Reveal>
      <div className="lg:col-span-7 lg:col-start-6 lg:ml-8 border-t border-[var(--ink)]">
        {OPTIONS.map((o, i) => (
          <Reveal key={o.id} delay={i * 0.08}>
            <Link
              to={o.to}
              className="group flex items-center justify-between gap-6 border-b border-[var(--line)] py-6"
              data-testid={`cta-${o.id}-link`}
            >
              <span className="text-lg sm:text-xl font-normal tracking-[-0.01em] transition-transform duration-500 group-hover:translate-x-1.5">{o.label}</span>
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-[var(--ink)] transition-[background-color,color,transform] duration-500 group-hover:bg-[var(--ink)] group-hover:text-[var(--paper)] group-hover:rotate-45">
                <ArrowUpRight className="h-4 w-4" strokeWidth={1.5} />
              </span>
            </Link>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
